import { createContext } from "react";
import { Locale } from "../api/dtos";


interface ILocaleActionContext {
    setLocale: (locale?: Locale) => Promise<void>; 
}

const LocaleActionContext = createContext<ILocaleActionContext>({
    setLocale: async () => undefined
});

export default LocaleActionContext;